__turbopack_context__.v({
  "content": "Tooltip-module-scss-module__cwfTWW__content",
  "has-content": "Tooltip-module-scss-module__cwfTWW__has-content",
  "open": "Tooltip-module-scss-module__cwfTWW__open",
  "tooltip-title": "Tooltip-module-scss-module__cwfTWW__tooltip-title",
});
